(ns bp-clients.tv-app.common.subs
  "Namespace for common subscriptions"
  (:require
   [bp-clients.tv-app.common.events :as common-events]
   [re-frame.core :refer [reg-sub]]))

(defn common-sub
  [db]
  (get db ::common-events/common))

(defn player-sub
  [{:keys [player]}]
  player)

(defn is-playing-sub
  [{:keys [playing?]}]
  (true? playing?))

(defn player-loading
  [{:keys [loading?]}]
  (true? loading?))

(defn current-media-sub
  [{:keys [media]}]
  media)

(defn is-welcome-modal-showed-sub
  [{:keys [welcome-modal-showed?]}]
  welcome-modal-showed?)

(defn error-queue-sub
  [{:keys [error-queue]}]
  error-queue)

(reg-sub ::common common-sub)
(reg-sub ::player :<- [::common] player-sub)
(reg-sub ::playing? :<- [::player] is-playing-sub)
(reg-sub ::player-loading? :<- [::player] player-loading)
(reg-sub ::current-media :<- [::player] current-media-sub)
(reg-sub ::welcome-modal-showed? :<- [::common] is-welcome-modal-showed-sub)
(reg-sub ::error-queue :<- [::common] error-queue-sub)
